import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DatesModule } from "../dates";

import { InputYearComponent } from "./year.component";

@NgModule({
  declarations: [InputYearComponent],
  imports: [CommonModule, DatesModule],
  exports: [InputYearComponent],
})
export class InputYearModule {}
